import { Box, Container, Typography } from '@mui/material';
import photo from '../assets/HeadBack.webp';
import backgroundImage from '../assets/modal.webp';
import PageBanner from './SectionPageBanner';

export default function TermsAndConditions() {
  return (
    <>
    <PageBanner image={photo} title="Terms and Conditions" />
    <Box
      sx={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        minHeight: '100vh',
        py: { xs: 6, md: 10 },
        px: 2,
        color: 'white',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <Container maxWidth="md">
        <Typography
          variant="body1"
          sx={{
            fontFamily: 'Nunito',
            lineHeight: 1.8,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            p: 3,
            borderRadius: 2,
          }}
        >
         These Terms and Conditions ("Terms") govern your access to and use of services provided by Loopsys Technologies, a company incorporated under the laws of India and having its registered office in Indore, Madhya Pradesh. By accessing our website, purchasing our services, or using any of our products, you agree to be bound by these Terms.
<br></br>
1. Definitions

Company: Refers to Loopsys Technologies Pvt. Ltd.

Services: IT services including but not limited to website development, application development, UI/UX design, digital marketing, software consulting, etc.

Products: Software or platforms developed and sold/licensed by Loopsys Technologies.

Client/User: Any person or entity using our services or purchasing our products.
<br></br>

2. Scope of Services

Loopsys Technologies provides a wide range of IT solutions and consulting services. A formal contract and service-level agreement (SLA) shall be agreed upon for each service rendered. The scope, duration, and deliverables for each project will be defined individually.
<br></br>
3. Product Terms

Products developed by Loopsys Technologies have their own individual Terms and Conditions and Privacy Policies that are published on their respective product websites. Clients are advised to review these documents before subscribing or using the products.
<br></br>
4. Payments and Refunds

All service fees and product subscriptions must be paid as per the agreement or invoice terms.

Late payments may attract interest charges or service suspension.

Refunds are subject to the refund policy mentioned in the service contract or product-specific T&C.
<br></br>
5. Intellectual Property

All intellectual property rights for custom-developed software, designs, and solutions remain with Loopsys Technologies unless explicitly transferred in writing.

Clients are granted a non-transferable, non-exclusive license to use the deliverables for their internal business purposes only.
<br></br>
6. Confidentiality

Both parties agree to keep confidential all information shared during the course of engagement. NDA (Non-Disclosure Agreement) may be executed separately if required.
<br></br>
7. Warranties and Liability

Loopsys Technologies provides services and products on an "as is" basis without warranties of any kind.

The Company is not liable for indirect, incidental, or consequential damages resulting from use of its services/products.

Maximum liability is limited to the fees paid by the client for the specific service/product.
<br></br>
8. Termination

Either party may terminate an engagement with 30 days written notice, unless otherwise agreed.

The Company may terminate services immediately in case of breach of contract, non-payment, or misuse of services.
<br></br>
9. Data Protection

The Company ensures reasonable security practices in line with applicable Indian IT laws.

Clients are responsible for maintaining the confidentiality of access credentials.
<br></br>
10. Governing Law and Dispute Resolution

These Terms shall be governed by the laws of India.

Any disputes arising shall be subject to the jurisdiction of the courts in Indore, Madhya Pradesh.
<br></br>
11. Changes to Terms

Loopsys Technologies reserves the right to update or modify these Terms at any time and will update the same on its website.
Clients are advised to review the Terms periodically.
 <br></br>
By using our website, you acknowledge that you have read, understood, and agree to these terms and policies.
        </Typography>
      </Container>
    </Box>
    </>
  );
}
